<template>
  <div class="quick-link-container">
    <a
      :class="['item', link.name]"
      v-for="(link, index) in cmsConfig.quickLink || []"
      :key="index"
      :href="link.href"
      @click="itemClickHandler(link)">
      <img :src="link.icon" alt="">
    </a>
  </div>
</template>

<script>
  import Cookies from 'js-cookie'
  export default {
    name: "quick-link",
    data() {
      return {
        visible: false,
        qqList: []
      }
    },
    props: {
      cmsConfig: {
        type: Object,
        default: () => {}
      }
    },
    async created() {
      
    },
    methods: {
      itemClickHandler (link) {
        let userId = Cookies.get('userId')
        if(link.callback === 'windowOpen'){
          let extra = link.extra && link.extra.split('*')
          let width = 750, height = 648
          if(Array.isArray(extra) && extra.length === 0){
            width = extra[0]
            height = extra[1]
          }
          let left = (window.screen.availWidth - width) / 2
          let top = 60
          window.open(`${link.link}&userId=${userId}`, '_blank', `width=${width},height=${height},left=${left},top=${top}`)
          return
        }
      },
      cancelHandler () {
        this.visible = false
      }
    },
  }
</script>

<style lang="scss" scoped>
.quick-link-container {
  position: fixed;
  bottom: 19%;
  right: 30px;
  /* 低于遮罩层 */
  z-index: 800;
  .item {
    text-align: center;
    display: block;
    margin-bottom: 12px;
    border-radius: 8px;
    img {
      width: 60px;
      height: 60px;
    }
    &.message, &.finance {
      background: #FFFFFF;
      box-shadow: 0px 2px 20px 0px rgba(52,55,61,0.07);
    }
    &.online {
      background-image: linear-gradient(180deg, #259FE8 0%, #1066CC 100%);
      box-shadow: 0px 2px 10px 0px rgba(35,153,229,0.15);
    }
  }
}
</style>
